module.exports = __webpack_public_path__ + "static/media/pact-ml-cert.b913e885.png";